import { CALL_API } from '../middleware/ApiMiddleware';

export const FETCH_SUBMISSION_SETTINGS_REQUEST = 'FETCH_SUBMISSION_SETTINGS_REQUEST';
export const FETCH_SUBMISSION_SETTINGS_SUCCESS = 'FETCH_SUBMISSION_SETTINGS_SUCCESS';
export const FETCH_SUBMISSION_SETTINGS_FAILURE = 'FETCH_SUBMISSION_SETTINGS_FAILURE';

export const UPDATE_SUBMISSION_SETTINGS_REQUEST = 'UPDATE_SUBMISSION_SETTINGS_REQUEST';
export const UPDATE_SUBMISSION_SETTINGS_SUCCESS = 'UPDATE_SUBMISSION_SETTINGS_SUCCESS';
export const UPDATE_SUBMISSION_SETTINGS_FAILURE = 'UPDATE_SUBMISSION_SETTINGS_FAILURE';

export const CLEAR_SUBMISSION_SETTINGS = 'CLEAR_SUBMISSION_SETTINGS';

const baseURL = 'agencies/crm/submission-settings';

export const fetchSubmissionSettings = () => ({
  [CALL_API]: {
    endpoint: baseURL,
    method: 'get',
    authenticated: true,
    types: [FETCH_SUBMISSION_SETTINGS_REQUEST, FETCH_SUBMISSION_SETTINGS_SUCCESS, FETCH_SUBMISSION_SETTINGS_FAILURE],
  },
});

export const updateSubmissionSettings = (submissionSettings: ISubmissionSettingsRequest) => ({
  [CALL_API]: {
    endpoint: baseURL,
    method: 'put',
    authenticated: true,
    body: submissionSettings,
    types: [UPDATE_SUBMISSION_SETTINGS_REQUEST, UPDATE_SUBMISSION_SETTINGS_SUCCESS, UPDATE_SUBMISSION_SETTINGS_FAILURE],
  },
});

export const clearSubmissionSettings = () => ({
  type: CLEAR_SUBMISSION_SETTINGS,
});
